module.exports = __webpack_public_path__ + "static/sample-projects-9-5ec835177ad1dfa06430dec3167d4d69.png";